(function () {
    'use strict';
    function onClick(e) {
        const btn = e.target.closest('[data-share]');
        if (!btn)
            return;

        e.preventDefault();

        const title = btn.getAttribute('data-share-title') || document.title || 'Check this out';
        const text = btn.getAttribute('data-share-text') || '';
        const url = btn.getAttribute('data-share-url') || location.href;

        if (navigator.share) {
            navigator.share({
                title, text, url
            }).catch(() => {
                /** return */
            });
          return;
        }

        // Fallback: copy URL to clipboard

        const toCopy = `${title}\n${text}\n${url}`.trim();

        navigator.clipboard?.writeText(toCopy).then(() => {
            window.toasts?.show('Link copied', 'URL copied to clipboard.', 'success');
        }).catch(() => {
            window.toasts?.show('Share', 'Copy failed. Please copy manually.', 'info');
        });
    }
    document.addEventListener('click', onClick);
})();